import request from '@/router/axios'

export function fetchTipRecordPage(params) {
  return request({
    url: '/admin/admin/tip-record/page',
    method: 'get',
    params
  })
}